import React from 'react';

import { CUSTOMER_DATA_TABS, LEAD_DETAILS_FORMS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import EmploymentForm from '~/features/leadDetails/components/Overview/CustomerData/Employment/EmploymentForm.tsx';
import { hide } from '~/features/leadDetails/components/Overview/CustomerData/General/utils/hide.ts';
import { ApplicantCollapsible } from '~/features/leadDetails/components/Overview/CustomerData/shared/ApplicantCollapsible.tsx';
import { useCustomerDataTabsContext } from '~/features/leadDetails/context/CustomerDataTabsContext.tsx';

type Props = {
    lead: SchemaLoanRequestResolver_Get;
};

const Employment: React.FC<Props> = ({ lead }) => {
    const { t } = useTranslation();
    const { notifications, tab } = useCustomerDataTabsContext();
    const getApplicantErrorCount = (formId: string) =>
        notifications[CUSTOMER_DATA_TABS.EMPLOYMENT].filter((notification) => notification.startsWith(`${formId}-`))
            .length;

    return (
        <div className="mb-2" style={hide(tab !== CUSTOMER_DATA_TABS.EMPLOYMENT)}>
            {lead.antragsteller2 ? (
                <div className="space-y-2">
                    <ApplicantCollapsible
                        applicant={1}
                        collapsible
                        errorCount={getApplicantErrorCount(LEAD_DETAILS_FORMS.EMPLOYMENT_APPLICANT1)}
                        testId="employment-applicant1"
                    >
                        <EmploymentForm lead={lead} key={lead.antragsteller1.id} />
                    </ApplicantCollapsible>
                    <ApplicantCollapsible
                        applicant={2}
                        collapsible
                        errorCount={getApplicantErrorCount(LEAD_DETAILS_FORMS.EMPLOYMENT_APPLICANT2)}
                        style={hide(lead.coApplicantHidden)}
                        testId="employment-applicant2"
                    >
                        <EmploymentForm lead={lead} key={lead.antragsteller2.id} secondApplicant />
                    </ApplicantCollapsible>
                </div>
            ) : (
                <EmploymentForm lead={lead} />
            )}
            {lead.coApplicantHidden && (
                <div className="flex justify-center my-6">
                    <span className="text-gray-400">{t('OVERVIEW.SECOND_APPLICANT_HIDDEN')}</span>
                </div>
            )}
        </div>
    );
};

export default Employment;
